<template>
	<div class="wuxing-page">
		<!-- 顶部导航栏 -->
		<div class="header-bar" @click="$router.back()">
			<van-icon name="arrow-left" class="back-icon" />
		</div>
		<div class="logo">
			<img class="logo-img" :src="logo" alt="五行商会" />
		</div>

		<!-- 回单卡片 -->
		<div class="receipt-card">
			<div class="receipt-content">
				<img class="receipt-image" :src="receiptImg" alt="电子回单" />
				<span class="name">{{ receiptData.bank_card_name }}</span>
				<span class="card-number">{{ receiptData.bank_card }}</span>
				<span class="amount">
					人民币（大写）{{ formatAmount }} ￥{{ receiptData.amount }}元
				</span>
				<span class="serial-number">{{ receiptData.serial_number }}</span>
				<span class="time">{{ receiptData.time }}</span>
				<span class="verification">{{ receiptData.verification_code }}</span>
			</div>
			<!-- <img class="receipt-tip" :src="receiptTip1Img" alt="正在审核打款，请您耐心等候" /> -->
			<img class="receipt-tip" :src="receiptTip2Img" alt="已入账，首次取款请预约银行线下激活" />
		</div>

		<!-- 按钮区域 -->
		<div class="button-group">
			<button v-if="is_appointment_withdrawal === 0" class="appointment-btn"
				@click="$router.push('/appointmentWithdrawal')">
				预约银行
			</button>
			<button v-else-if="is_appointment_withdrawal === 1" class="progress-btn"
				@click="$router.push('/appointmentInfo')">
				查看预约进度
			</button>
		</div>

		<div class="receipt-progress">
			<!-- <img class="progress-img" :src="receiptProgress1Img" alt="进度条" /> -->
			<img class="progress-img" :src="receiptProgress2Img" alt="进度条" />
		</div>

		<!-- 加载状态 -->
		<div v-if="loading" class="loading">
			加载中...
		</div>
	</div>
</template>

<script>
	import Fetch from "../../utils/fetch";
	import logoImg from '@/assets/withdraws/logo.png';
	import receiptImg from '@/assets/withdrawBankCard/receipt.png';
	import receiptTip1Img from '@/assets/withdrawBankCard/receipt_tip1.png';
	import receiptTip2Img from '@/assets/withdrawBankCard/receipt_tip2.png';
	import receiptProgress1Img from '@/assets/withdrawBankCard/receipt_progress1.png';
	import receiptProgress2Img from '@/assets/withdrawBankCard/receipt_progress2.png';

	export default {
		name: 'electronicReceipt',
		data() {
			return {
				logo: logoImg,
				receiptImg: receiptImg,
				receiptTip1Img: receiptTip1Img,
				receiptTip2Img: receiptTip2Img,
				receiptProgress1Img: receiptProgress1Img,
				receiptProgress2Img: receiptProgress2Img,
				receiptData: {
					bank_card_name: '',
					bank_card: '',
					amount: '',
					serial_number: '',
					time: '',
					verification_code: ''
				},
				loading: true,
				is_appointment_withdrawal: 0
			}
		},
		created() {
			this.$parent.footer('electronicReceipt', false);
		},
		mounted() {
			this.fetchReceiptData();
			this.fetchUserInfo();
		},
		computed: {
			formatAmount() {
				const amount = parseFloat(this.receiptData.amount);
				return this.convertCurrency(amount);
			}
		},
		methods: {
			fetchReceiptData() {
				this.loading = true;
				Fetch("/user/get_receipt_data")
					.then(res => {
						if (res.code === 1) {
							this.receiptData = res.data;
						}
					}).catch(err => {
						console.error(err);
					}).finally(() => {
						this.loading = false;
					});
			},

			fetchUserInfo() {
				Fetch("/user/info")
					.then((r) => {
						this.is_appointment_withdrawal = r.data.is_appointment_withdrawal;
					}).catch(e => {
						console.error('Fetch /user/info failed', e);
					});
			},

			// 优化的转换函数
			convertCurrency(money) {
				// 处理负数和空值
				if (money == null || isNaN(money)) return '零元整';

				const amount = parseFloat(money);
				if (amount === 0) return '零元整';
				if (amount < 0) return '负' + this.convertCurrency(Math.abs(amount));

				// 转换为两位小数的字符串
				const numStr = amount.toFixed(2);
				const [integerPart, decimalPart] = numStr.split('.');

				// 中文数字和单位
				const cnNums = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
				const cnIntUnits = ['', '拾', '佰', '仟'];
				const cnGroupUnits = ['', '万', '亿'];
				const cnDecUnits = ['角', '分'];

				// 转换整数部分
				let result = '';
				let zeroFlag = false; // 标记上一位是否是零

				// 将整数部分分成4位一组（从低位到高位）
				const groups = [];
				for (let i = integerPart.length; i > 0; i -= 4) {
					groups.push(integerPart.slice(Math.max(0, i - 4), i));
				}
				groups.reverse(); // 反转，从高位组到低位组

				// 处理每一组
				for (let i = 0; i < groups.length; i++) {
					const group = groups[i];
					let groupResult = '';
					let groupZeroFlag = false; // 标记组内是否有非零数字

					// 处理组内每一位
					for (let j = 0; j < group.length; j++) {
						const digit = parseInt(group.charAt(j));
						const unitIndex = (group.length - 1 - j) % 4;

						if (digit === 0) {
							if (!zeroFlag) {
								zeroFlag = true;
							}
						} else {
							if (zeroFlag && groupResult !== '') {
								groupResult += cnNums[0];
								zeroFlag = false;
							}
							groupResult += cnNums[digit] + cnIntUnits[unitIndex];
							groupZeroFlag = true;
						}
					}

					// 添加组单位（万、亿等）
					if (groupZeroFlag) {
						result += groupResult + cnGroupUnits[groups.length - 1 - i];
						zeroFlag = false;
					} else if (result !== '' && i < groups.length - 1) {
						// 全零组，检查后面的组是否有非零数字
						let hasNonZeroInLaterGroups = false;
						for (let k = i + 1; k < groups.length; k++) {
							if (parseInt(groups[k]) > 0) {
								hasNonZeroInLaterGroups = true;
								break;
							}
						}
						if (hasNonZeroInLaterGroups) {
							result += cnNums[0];
						}
					}
				}

				// 处理结果末尾可能的多余的"零"
				if (result.endsWith(cnNums[0])) {
					result = result.slice(0, -1);
				}

				// 处理"壹拾"的情况
				if (result.startsWith(cnNums[1] + '拾')) {
					result = result.substring(1);
				}

				// 如果整数部分为空，添加"零"
				if (result === '') {
					result = '零';
				}

				// 转换小数部分
				let decimalStr = '';
				const jiao = parseInt(decimalPart.charAt(0));
				const fen = parseInt(decimalPart.charAt(1));

				if (jiao > 0) {
					decimalStr += cnNums[jiao] + cnDecUnits[0];
				}

				if (fen > 0) {
					decimalStr += cnNums[fen] + cnDecUnits[1];
				}

				// 组合结果
				let finalResult = result + '元';
				if (decimalStr === '') {
					finalResult += '整';
				} else {
					// 如果角为0分不为0，需要加"零"
					if (jiao === 0 && fen > 0) {
						finalResult += '零' + decimalStr;
					} else {
						finalResult += decimalStr;
					}
				}

				return finalResult;
			}
		}
	}
</script>

<style lang="less" scoped>
	.wuxing-page {
		height: 100vh;
		background-image: url('../../assets/withdraws/withdraws-bg.png');
		background-size: cover;
		background-position: center;
		// padding: 20px;
		color: #333;
		position: relative;
		overflow: hidden;
	}

	/* 顶部导航 */
	.header-bar {
		width: 100%;
		display: flex;
		align-items: center;
		padding: 4.26667vw;
		padding-bottom: 0;
	}

	.header-bar .back-icon {
		font-size: 6.4vw;
		color: #fff;
		text-shadow: 0 1px .53333vw rgba(0, 0, 0, .3);
	}

	.logo {
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 12px 0;
		margin-bottom: 16px;
	}

	.logo-img {
		// height: 70px;
		width: 80%;
		object-fit: contain;
		display: block;
	}

	.receipt-card {
		width: 90%;
		// display: flex;
		// justify-content: center;
		align-items: center;
		padding: 10px;
		margin: 0 auto 36px;
		overflow: hidden;
		border-radius: 10px;
		background-color: #fff;
		font-family: "仿宋_GB2312", "FangSong_GB2312", "FangSong", "SimSun", "宋体", "Microsoft YaHei", sans-serif;

		.receipt-content {
			position: relative;
			border-radius: 10px;
			box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);

			.receipt-image {
				width: 100%;
				// height: 90px;
				object-fit: contain;
				display: block;
				border-radius: 10px;
			}

			.name {
				position: absolute;
				top: 33%;
				right: 17%;
				z-index: 10;
				font-size: 8px;
			}

			.card-number {
				position: absolute;
				top: 42%;
				right: 10%;
				z-index: 10;
				font-size: 8px;
			}

			.amount {
				position: absolute;
				top: 53%;
				left: 15%;
				z-index: 10;
				font-size: 8px;
			}

			.serial-number {
				position: absolute;
				top: 70%;
				left: 15%;
				z-index: 10;
				font-size: 8px;
			}

			.time {
				position: absolute;
				top: 70%;
				right: 14%;
				z-index: 10;
				font-size: 8px;
			}

			.verification {
				position: absolute;
				bottom: 5%;
				left: 22%;
				z-index: 10;
				font-size: 8px;
			}
		}

		.receipt-tip {
			width: 90%;
			display: block;
			margin: 15px auto 0;
		}
	}

	/* 按钮组样式 */
	.button-group {
		width: 40%;
		margin: 0 auto 36px;
		display: flex;
		justify-content: center;

		.appointment-btn,
		.progress-btn {
			width: 100%;
			padding: 15px;
			border: 2px solid #fff;
			border-radius: 15px;
			font-size: 18px;
			font-weight: bold;
			color: #fff;
			background-color: #ff4d4f;
			cursor: pointer;
			transition: all 0.3s ease;
			display: flex;
			align-items: center;
			justify-content: center;
			box-shadow: 0 4px 12px rgba(255, 77, 79, 0.3);

			&:active {
				transform: scale(0.98);
				background-color: #ff3333;
			}

			&:hover {
				background-color: #ff3333;
				box-shadow: 0 6px 15px rgba(255, 77, 79, 0.4);
			}
		}
	}

	.receipt-progress {
		.progress-img {
			width: 90%;
			display: block;
			margin: 0 auto 0;
		}
	}

	.loading {
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		background: rgba(0, 0, 0, 0.7);
		color: white;
		padding: 10px 20px;
		border-radius: 5px;
	}
</style>